<template>
    <div>

        <div>


            <div class="info-title">供应商信息</div>

            <div  class="form-info-panel" style="padding-left: .4rem;text-align: left;">


                <div class="cus-row cus-row-v-m">
                    <div class="cus-row-col-3"><span class="input-tag">供应商</span></div>
                    <div class="cus-row-col-9 select-line" @click="picSupplier">
                        <input class="line-input" placeholder="请输入" :value="supplier.supplier_name" onfocus="this.blur()" readonly/>
                    </div>
                </div>



                    <div class="barrie-line"></div>

                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">联系人</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入" :value="supplier.contact_name" onfocus="this.blur()" readonly/>
                        </div>
                    </div>

                    <div class="barrie-line"></div>

                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">联系电话</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入" :value="supplier.contact_phone" onfocus="this.blur()" readonly/>
                        </div>
                    </div>

                    <div class="barrie-line"></div>

                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">地址</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入" :value="supplier.address" onfocus="this.blur()" readonly/>
                        </div>
                    </div>

                    <div class="barrie-line"></div>

                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">邮箱</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入" :value="supplier.email" onfocus="this.blur()" readonly/>
                        </div>
                    </div>

                    <div class="barrie-line"></div>

                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">收款开户行</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入" :value="payment.bank_name"/>
                        </div>
                    </div>



                    <div class="barrie-line"></div>

                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">收款开户名</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入" :value="payment.bank_account_name"/>
                        </div>
                    </div>

                    <div class="barrie-line"></div>

                    <div class="cus-row cus-row-v-m">
                        <div class="cus-row-col-3"><span class="input-tag">收款账号</span></div>
                        <div class="cus-row-col-9 select-line">
                            <input class="line-input" placeholder="请输入" :value="payment.bank_account" type="number"/>
                        </div>
                    </div>

                </div>

            </div>


        <div class="info-title">付款金额</div>

        <div   class="form-info-panel" style="padding-left: .4rem;text-align: left;">

            <div class="cus-row cus-row-v-m">
                <div class="cus-row-col-4"><span class="input-tag">金额</span></div>
                <div class="cus-row-col-8 select-line">
                    <input class="line-input" placeholder="请输入" :value="payment.price"/>
                </div>
            </div>

        </div>

        <div class="info-title">付款资料</div>

        <div style="padding-left: .4rem">
            <div style="width: 3rem;height: 3rem;background-color: #ffffff;    border: 0.05rem solid rgb(204, 204, 204);" @click="uploadImg(1)">
                <div style="text-align: center;" v-if="!faceImg"><van-icon name="plus" style="line-height: 3rem;font-size: .8rem;"/></div>
                <img style="width: 100%;height: 100%;" :src="facePath" v-else/>
            </div>
        </div>


        <form style="display: none;" id="data-form">
            <input id="fileTarget" ref="filElem" type="file" name="file"  style="display: none" accept="image/gif,image/jpeg,image/png"  @change="getFile"/>
        </form>

        <CusDatePicker ref="begin_time_select" v-model="pay_date"></CusDatePicker>

    </div>
</template>


<script>
    import common from '../assets/js/common'
    import CusDatePicker from '../modules/cus_date_picker'
    import store from '../store'
    import { Dialog  } from "vant"

    export default {
        name: 'HelloWorld',
        props: {
            msg: String
        },
        components:
            {
                CusDatePicker
            },
        data: function(){
            return {
                begin_time:'',
                price:'',
                pay_username:'',
                collection_username:'',
                pay_date:'',
                faceImg:'',
                supplier_id:'',
                supplier_name:'',
                contact_name:'',
                contact_phone:'',
                address:'',
                email:'',
                bank_account_name:'',
                bank_account:'',
                bank_name:'',
                supplier:'',
                payment:''
            }
        },
        methods:{
            goSms(){
                if(!(/^1[0-9]\d{9}$/.test(this.mobile))) {
                    this.$layer.msg('请输入正确的手机号');
                    return;
                }

                if (!(/^[0-4|6-9][0-9]{15,18}$/.test(this.account))) {
                    common.mAlert(this,'请输入正确的银行卡号');
                    return;
                }

                if (!this.mobile) {
                    common.mAlert(this,'银行预留手机号不能为空');
                    return;
                }

                if ( this.second ) {
                    return;
                }


                this.second = 60;
                this.smsText = this.second + '秒';
                this.smsFlag = true;

                (function(a){
                    var countDownHandler = setInterval(function(){
                        a.second = a.second - 1;
                        if( a.second < 1) {
                            clearInterval(countDownHandler);
                            a.second = 0;
                            a.smsText = '获取验证码';
                            return;
                        }
                        a.smsText = a.second + '秒';
                    },1000);
                })(this);


                this.$http.post(common.dynamicHost() + '/bor/bankcard',{id:this.id,mobile:this.mobile,bank_code:this.bank_code,account:this.account}).then((res)=>{
                    if( res.data.status )
                    {
                        this.$layer.msg('发送成功');
                    }
                }).catch(err=>{

                });
            },
            showBank()
            {
                common.setTitle('绑定还款银行卡');
                this.bankShow = true;
            },
            nextStep(){


                if( !this.supplier_id )
                {
                    common.mAlert(this,'请选择供应商');
                    return;
                }

                //验证
                if (!this.bank_name) {
                    // this.$layer.msg('请输入课程名称')
                    common.mAlert(this,'收款开户行不能为空');
                    return;
                }

                if (!this.bank_account_name) {
                    // this.$layer.msg('请输入课程名称')
                    common.mAlert(this,'收款开户名不能为空');
                    return;
                }

                if (!this.bank_account) {
                    common.mAlert(this,'收款账号不能为空');
                    return;
                }

                if( !this.price )
                {
                    common.mAlert(this,'金额不能为空');
                    return;
                }

                if( !this.faceImg )
                {
                    common.mAlert(this,'请上传付款资料');
                    return;
                }

                // location.href = 'status'

                common.cusHttp(this,'/api/save_payment',{id:this.supplier_id,supplier_name:this.supplier_name,contact_name:this.contact_name,contact_phone:this.contact_phone,address:this.address,email:this.email,bank_name:this.bank_name,bank_account_name:this.bank_account_name,bank_account:this.bank_account,price:this.price,attachment:this.faceImg},'post').then((res)=>{
                    if( res.data.errcode == 0 )
                    {
                        // location.href = 'protocol?id=' + this.id
                        Dialog.confirm({
                            title: '添加成功',
                            message: '是否留在当前页面继续添加？'
                        }).then(() => {
                            // on confirm
                            //TODO:清空
                            // this.pay_username = '';
                            // this.collection_username = '';
                            // this.price = '';
                            // this.pay_date = moment().format('YYYY-MM-DD')
                            // this.attachment = '';
                        }).catch(() => {
                            // on cancel
                            //返回上一页
                            this.$router.push('/payment')
                        });
                    }else
                    {
                        common.mAlert(this,res.data.errmsg)
                    }
                }).catch(err=>{

                });
            },
            closeLayer:function()
            {
                this.layerFlag = false;
            },
            initPage()
            {
                common.cusHttp(this,'/bor/loan_detail',{id:this.id},'get').then((res)=>{
                    if (res.data.errcode == 0)
                    {
                        this.loan_detail = res.data.loan_detail;
                        //取最后一个资方
                        this.capital = res.data.loan_detail.applications.slice(-1)[0];
                    }
                })

                common.cusHttp(this,'/bor/bank_list',{},'get').then((res)=>{
                    if (res.data.errcode == 0)
                    {
                        /*改成自定义系统select支持的数据格式*/
                        let bankArrTmp = [];
                        for( var i = 0 , j = res.data.data.length; i < j; i++ )
                        {
                            bankArrTmp.push({fields:{item_value:res.data.data[i].bank_code,item_name:res.data.data[i].bank_name}});
                        }

                        this.bankArr = bankArrTmp;


                        // this.bankArr  = res.data.data;
                    }
                })
            },
            uploadImg(){
                this.$refs.filElem.dispatchEvent(new MouseEvent('click'))
            },
            getFile()
            {
                // var that = this;
                const inputFile = this.$refs.filElem.files[0];
                if(inputFile){
                    if(inputFile.type !== 'image/jpeg' && inputFile.type !== 'image/png' && inputFile.type !== 'image/gif'){
                        alert('不是有效的图片文件！');
                        return;
                    }

                    var formElement = document.querySelector("#data-form");
                    var formData = new FormData(formElement);


                    common.cusHttp(this,'/api/api-cloud-img',formData,'post').then((res)=>{
                        this.$refs.filElem.value = '';
                        res = JSON.parse(res.data)
                        if( res.status )
                        {
                            this.faceImg = res.data;
                        }
                    }).catch(err=>{
                        common.mAlert(this,'银行卡识别失败');
                    });
                } else {
                    return;
                }
            },
            picSupplier()
            {
                this.$router.push('/suppliers')
            }
        },
        created:function()
        {
            /**
             * 如果没有token则跳到登录页哟
             */
            common.checkToken(this)

            common.setTitle('确认信息');
            this.id = common.queryValue('id');
        },
        mounted()
        {
            common.cusHttp(this,'/api/payment_detail',{id:this.$route.query.id}).then((res)=>{
                this.payment = res.data.payment;
                this.supplier = res.data.supplier;
                this.faceImg = res.data.payment.attachment;
            })
        },
        onShow()
        {
            console.log('显示了哟')
        },
        computed:{
            nextStepValid:function () {
                return true;
            },
            facePath:function(){
                return common.dynamicHost() + this.faceImg;
            },
            pickSupplier()
            {
                //选择supplier
                this.$router.push('/suppliers')
            }
        }
    }
</script>


<style>

    html,body{background-color: #f8f8f8!important;}

    input::-webkit-input-placeholder{
        padding-top: 0;
        line-height: normal ;
    }

    input{
        color: #999999 !important;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }
    #nav {
        padding: 30px;
    }

    #nav a {
        font-weight: bold;
        color: #2c3e50;
    }

    #nav a.router-link-exact-active {
        color: #42b983;
    }

    .inEdit
    {
        opacity: .4;
    }

    .disableText{color:#999999 !important;}

    .in-bl{display: inline-block;}

    .common-padding{padding: 0 0.625rem;}
    .common-padding2{padding: 0.4rem 0.625rem;}

    .fc-aaaaaa-fs-nor-m{font-family: PingFangSC-Medium;font-size: 0.4375rem;color: #AAAAAA;line-height: .625rem;}

    .camera_text{line-height: 0.4rem;font-family: PingFangSC-Regular;font-size: 0.3rem;font-weight: normal;font-stretch: normal;letter-spacing: 0rem;color: #1889f9;}

    .bank-desc
    {
        font-family: PingFangSC-Regular;
        font-size: 0.438rem;
        color: #111111;
        line-height: 0.625rem;
    }
</style>